// Fields the backend sends on `userInfo` to open an unreleased section per merchant. Only an
// explicit `true` opens one: a merchant without the field keeps the SOON placeholder.
export const FEATURE_FLAGS = {
  RECEIPTS: "is_receipts_allowed"
}

export const isFeatureUnlocked = (userInfo, flag) => !flag || userInfo?.[flag] === true
